enum JobAction {
  CANCEL = "cancel",
  ARCHIVE = "archive",
}

export default JobAction;
